import React from 'react';
import {Box, Stack, Tooltip, Typography} from "@mui/material";

type MessageReferenceProps = {
    referencia: string
    id?: number
    nombreEtapaActual?: string
    hideReferencia?: boolean
}

function MessageReference({ referencia, id, nombreEtapaActual, hideReferencia = false }: MessageReferenceProps) {
    return (
        <>
          {!hideReferencia && (
            <Tooltip title={referencia}>
              <Typography noWrap variant='body2' minWidth={0}>
                  <Box component='span' sx={{ fontWeight: 600, fontSize: '0.8125em' }}>
                      {'Ref.: '}
                  </Box>
                  {referencia}
              </Typography>
            </Tooltip>
          )}
          <Stack direction='row' alignItems='center' spacing={1} minWidth={0}>
            {nombreEtapaActual && (
              <Tooltip title={nombreEtapaActual}>
                <Typography noWrap variant='body2' minWidth={0}>
                    <Box component='span' sx={{ fontWeight: 600, fontSize: '0.8125em' }}>
                        {'Etapa: '}
                    </Box>
                    {nombreEtapaActual}
                </Typography>
              </Tooltip>
            )}
          </Stack>
          {id !== undefined && (
              <Typography noWrap variant='body2' minWidth={0}>
                  <Box component='span' sx={{ fontWeight: 600, fontSize: '0.8125em' }}>
                      {'Id: '}
                  </Box>
                  {id}
              </Typography>
          )}
        </>
    );
}

export default MessageReference;
